<template>
    <div class="card">
        <h5>{{ $t('menu.lsportsSports') }}</h5>
        <SportEntities :entityType="'sport'"></SportEntities>
    </div>
</template>
<script>
import SportEntities from './SportEntities.vue';
export default {
    name: 'lsportsSports',
    components: {
        SportEntities,
    },
    data() {
        return {};
    },
};
</script>
